/* istanbul ignore file */

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    line-height: 1.5;
  }
  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
  }

  :root {
    --ant-font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    --ant-font-family-code: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  /* Some components inherit from this */
  .ant-typography,
  .ant-btn,
  .ant-input,
  .ant-select,
  .ant-menu,
  .ant-table,
  .ant-modal,
  .ant-dropdown,
  .ant-tooltip {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    letter-spacing: 0.5px;
  }
`;

export default GlobalStyle;
